"use strict";
import { createHistory } from "history";
import { useRouterHistory } from "react-router";
export { parsePath } from "history/lib/PathUtils";
export default function createLegacyHistory(basename) {
  return useRouterHistory(createHistory)({ basename });
}
